/**
* 采集实时数据
*/
const measuring = {

  getMeasuringValue: "/api/getMeasuringValue",//查询所有瞬时数据
  getMeasuringValue2: "/api/getMeasuringValue2",//查询所有瞬时数据
  getMeasuringValueHour: "/api/getMeasuringValueHour",//查询时瞬时数据
  getMeasuringValueDay: "/api/getMeasuringValueDay",//查询时瞬时数据
  getMeasuringValueMonth: "/api/getMeasuringValueMonth",//查询时瞬时数据
  getMeasuringValueYear: "/api/getMeasuringValueYear",//查询时瞬时数据
  getMeasuringValueHour2: "/api/getMeasuringValueHour2",//查询时瞬时数据
  getMeasuringValueDay2: "/api/getMeasuringValueDay2",//查询时瞬时数据
  getMeasuringValueMonth2: "/api/getMeasuringValueMonth2",//查询时瞬时数据
  getMeasuringValueYear2: "/api/getMeasuringValueYear2",//查询时瞬时数据
  getMeasuringValueMaxMin: "/api/getMeasuringValueMaxMin",//查询瞬时数据最大值最小值
  getMeasuringValueMaxMinHour: "/api/getMeasuringValueMaxMinHour",//查询瞬时数据最大值最小值
  getMeasuringValueMaxMinDay: "/api/getMeasuringValueMaxMinDay",//查询瞬时数据最大值最小值
  getMeasuringValueMaxMinMonth: "/api/getMeasuringValueMaxMinMonth",//查询瞬时数据最大值最小值
  getMeasuringValueMaxMinYear: "/api/getMeasuringValueMaxMinYear",//查询瞬时数据最大值最小值
  getLatestMeasuringValue: "/api/getLatestMeasuringValue",//最新原始值查询
  getMeasuringValueAll2: "/api/getMeasuringValueAll2",//查询所有瞬时数据
}

export default measuring